module.exports = __webpack_public_path__ + "img/aot_1.a4a02bd2.gif";